import AICreationUpload from './AICreationUpload'

export default AICreationUpload
